export const normalizeEmail = (email) => {
  if (typeof email !== 'string') return email;
  return email.trim().toLowerCase();
};

export const normalizeRecipient = (recipient) => {
  if (!recipient || typeof recipient !== 'object') return recipient;
  return {
    ...recipient,
    email: normalizeEmail(recipient.email),
  };
};

export const normalizeScheduleRecipient = (entry) => {
  if (!entry || typeof entry !== 'object') return entry;
  return {
    ...entry,
    recipient: normalizeRecipient(entry.recipient),
  };
};

export const normalizeReportSchedule = (schedule) => {
  if (!schedule || typeof schedule !== 'object') return schedule;
  return {
    ...schedule,
    created_by: normalizeRecipient(schedule.created_by),
    report_schedule_recipients: Array.isArray(schedule.report_schedule_recipients)
      ? schedule.report_schedule_recipients.map(normalizeScheduleRecipient)
      : [],
  };
};

export const normalizeReportSchedules = (schedules) => {
  if (!Array.isArray(schedules)) return [];
  return schedules.map(normalizeReportSchedule);
};

export const normalizeRunDetailsResponse = (response) => {
  if (!response || typeof response !== 'object') return response;
  return {
    ...response,
    items: Array.isArray(response.items)
      ? response.items.map((item) => {
        if (!item || typeof item !== 'object') return item;
        return {
          ...item,
          email: normalizeEmail(item.email),
        };
      })
      : [],
  };
};
